var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOrangeTickP = function SvgOrangeTickP(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.985,
    height: 36.49,
    viewBox: "0 0 35.985 36.49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18602",
    "data-name": "Group 18602",
    transform: "translate(-47.033 -284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(47.033 284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M40.351,25.666a6.161,6.161,0,0,1,0-4.621l.2-.486a6.129,6.129,0,0,0-3.237-7.945l-.44-.2a5.894,5.894,0,0,1-3.237-3.283l-.16-.405A6.061,6.061,0,0,0,25.6,5.439l-.4.162a6.019,6.019,0,0,1-4.6,0l-.36-.162a6.005,6.005,0,0,0-7.794,3.324l-.16.324A5.894,5.894,0,0,1,9.056,12.37l-.36.162a6.145,6.145,0,0,0-3.2,7.945l.16.365a6.161,6.161,0,0,1,0,4.621l-.16.446a6.035,6.035,0,0,0,3.237,7.9l.4.162a5.894,5.894,0,0,1,3.237,3.283l.2.446a5.944,5.944,0,0,0,7.794,3.324l.44-.2a6.019,6.019,0,0,1,4.6,0l.36.162A5.982,5.982,0,0,0,33.6,37.7l.16-.324A5.894,5.894,0,0,1,36.994,34.1l.32-.122a6.08,6.08,0,0,0,3.237-7.945ZM21.327,31.138h0L13.533,24.49l2.4-2.878,4.956,4.256L29.64,15.329l2.838,2.432L21.327,31.138Z",
    transform: "translate(-5.033 -4.988)",
    fill: "#f5722c"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrangeTickP, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orangeTickP.9791dcb7.svg";
export { ForwardRef as ReactComponent };